export default "__VITE_ASSET__BYHGlhFO__"